import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/api/admin/agent/actions/process';

interface IProcessRequest {
  securityKey: string;
  guid: string;
}

interface IProcessResult {
  total: number;
  current: number;
  message: string;
}

export default {
  process(hostName: string, nodeName: string, isHongKong: boolean, req: IProcessRequest, success: (res: IProcessResult) => void) {
    utils.loading(true);
    const hostRequest = utils.getHostRequest(hostName, nodeName, isHongKong);
    hostRequest
      .post($url, req)
      .then((response: AxiosResponse<IProcessResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
